import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import RedirectOnLoggedIn from '../../util/RedirectOnLoggedIn'
import RequiredAuth from '../../util/RequiredAuth'
import Layout from '../pages/dashboard/Layout'
import Settings from '../pages/setting/Settings'
import { AllRoutes } from './AllRoutes'
import { settingRoutes } from './SettingRoutes'
import { auth_routes } from './UnProtectedRoutes'
import { reportRoutes } from './ReportRoutes'
import Reports from '../pages/reports/Reports'
import PageNotFound from '../pages/PageNotFound'
import { getLoggedInUser } from '../../auth/authUtil'


const getRequiredRoute = () => {
    let user = getLoggedInUser();
    let filterRoutes = reportRoutes.filter(route =>
        user?.authorities?.some(item => route.permissions.includes(item))
    );
   return filterRoutes
}

export const AppRoutes = () => {
    const [route, setRoute] = useState([]);

    useEffect(() => {
        const filteredRoutes = getRequiredRoute();
        setRoute(filteredRoutes);
    }, []);
    return (
        <Routes>
            {
                auth_routes.map(e => {
                    return <Route
                        key={e.path}
                        path={e.path}
                        element={
                            <RedirectOnLoggedIn>
                                {e.ele}
                            </RedirectOnLoggedIn>
                        }
                    />
                })
            }
            <Route path="/" element={<Layout />} >
                {
                    AllRoutes.map((e) => {
                        return (
                            <Route
                                key={e.path}
                                path={e.path}
                                element={
                                    <RequiredAuth userRoles={e?.permissions}>
                                        {e.element}
                                    </RequiredAuth>
                                }
                            />
                        );
                    })
                }
                <Route path="/settings" element={<Settings />} >
                    {
                        settingRoutes.map((e) => {
                            return (
                                <Route
                                    key={e.path}
                                    path={e.path}
                                    element={
                                        <RequiredAuth userRoles={e?.permissions}>
                                            {e.element}
                                        </RequiredAuth>
                                    }
                                />
                            );
                        })
                    }
                </Route>
                <Route path="/reports" element={<Reports />} >
                    {
                        reportRoutes.map((e) => {
                            return (
                                <Route
                                    key={e.path}
                                    path={e.path}
                                    element={
                                        <RequiredAuth userRoles={e?.permissions}>
                                            {e.element}
                                        </RequiredAuth>
                                    }
                                />
                            );
                        })
                    }
                </Route>
                <Route path="*" element={<PageNotFound/>}></Route>
            </Route>
        </Routes>
    )
}
